import hash = require("object-hash");
import _ = require("lodash");
import { CellType, ExcelColorValue, UploadStatus, Constants, ColumnType } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource } from "../../util/utils";
import Utility from "../../util/utilityFunctions";
import { TemplateUIExcelInterface } from "../../services/template/TemplateUIExcelInterface";
import { wrap } from "module";

export class ItgcConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true, // This can be only one
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.itgcName,
        CellId: "ItgcName",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 278.57,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.itControlName;
        },
      },

      {
        CellHeader: labels.frequency,
        CellId: "Frequency",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const itApplicationControl = 7;
          const sourceData = currentResource.controlFrequencyNameTypes.filter(
            (frequencyType) => frequencyType.value != itApplicationControl
          );

          const dataObject = sourceData.find((x) => x.value === data.controlFrequencyTypeId);
          return dataObject ? dataObject.label : "";
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.controlFrequencyNameTypes : currentResource.controlFrequencyNameTypes;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.designEffectiveness,
        CellId: "DesignEffectiveness",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.controlDesignEffectivenessType.find(
            (x) => x.value === data.controlDesignEffectivenessTypeId
          );
          return dataObject ? dataObject.label : "";
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage
              ? userLanguage.controlDesignEffectivenessType
              : currentResource.controlDesignEffectivenessType;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.operatingEffectiveness,
        CellId: "OperatingEffectiveness",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.operativeEffectivenessType.find((x) => x.value === data.isEffective);
          return dataObject ? dataObject.label : "";
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.operativeEffectivenessType : currentResource.operativeEffectivenessType;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.testing,
        CellId: "Testing",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.YesNoTypes.find((x) => x.booleanValue === data.hasITControlTesting);
          return dataObject ? dataObject.label : "";
        },
        validateImpactedCells: (updatedValue, validateRule, rowData, referenceData, rowInputPayload) => {
          let validationMessage = null;
          const errorDetails = {
            errorCode: 84031,
            defaultMessage: "invalid data",
          };

          const impactedCellDetail = this.columns.find((x) => x.CellId == "OperatingEffectiveness");
          let updatedValueImpactedCell = rowData[impactedCellDetail.CellDisplayIndex];
          if (referenceData) {
            let referenceDataValue = referenceData.find((x) => x.label === updatedValue);
            if (referenceDataValue && referenceDataValue.value === 0) {
              if (!Utility.isInvalidValue(updatedValueImpactedCell)) {
                validationMessage = TemplateUIExcelInterface.getErrorMessage(impactedCellDetail, errorDetails);
              }
            }
          }

          return validationMessage;
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.itgcName + " ",
        CellId: "OriginalItgcName",
        CellFormat: {
          locked: true,
          requiredColumnWidth: 278.57,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.itControlName;
        },
      },
      {
        CellHeader: labels.frequency + " ",
        CellId: "OriginalFrequency",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.controlFrequencyNameTypes.find(
            (x) => x.value === data.controlFrequencyTypeId
          );
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.designEffectiveness + " ",
        CellId: "OriginalDesignEffectiveness",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.controlDesignEffectivenessType.find(
            (x) => x.value === data.controlDesignEffectivenessTypeId
          );
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.operatingEffectiveness + " ",
        CellId: "OriginalOperatingEffectiveness",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.operativeEffectivenessType.find((x) => x.value === data.isEffective);
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.testing + " ",
        CellId: "OriginalTesting",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          const dataObject = currentResource.YesNoTypes.find((x) => x.booleanValue === data.hasITControlTesting);
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.itControlId + " ",
        CellId: "itControlId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.id;
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "ItgcName",
            },
            {
              CellId: "Frequency",
            },
            {
              CellId: "DesignEffectiveness",
            },
            {
              CellId: "OperatingEffectiveness",
            },
            {
              CellId: "Testing",
            },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data); // can be more then one
          return hashValue;
        },
      },
      {
        CellHeader: labels.statusId,
        CellType: CellType.DynamicCell,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "H1:L1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:G1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
